export default __webpack_public_path__ + "static/media/12-large.72d9cc1c.jpg";